import React, { useState } from "react";
import ClientBackground from "./ClientBackground";
import { ChevronLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";

export default function QuestionandAnswer({ title }) {
  const navigate = useNavigate();
  const { childId } = useParams();
  const [isNavigating, setIsNavigating] = useState(false);

const handleAskTufyClick = async () => {
  setIsNavigating(true);
  try {
    const response = await api.get(`/children/profiles/${childId}/?timestamp=${new Date().getTime()}`);

    console.log("API Response:", response.data); // <-- prints in browser console

    const tufyEnabled = response.data.tufy_page;
    if (tufyEnabled) {
      navigate(`/tufy-chat-center/${childId}`);
    } else {
      navigate(`/tufy-landing/${childId}`);
    }
  } catch (error) {
    console.error("Error fetching child profile:", error);
  } finally {
    setIsNavigating(false);
  }
};

  return (
    <div className="relative min-h-screen">
      <ClientBackground />
      <div className="relative z-10">
        {/* Header */}
        <div className="bg-white/0 backdrop-blur-sm px-5 py-4 flex items-center justify-between">
          <button onClick={() => navigate(`/child/${childId}`)} className="p-2">
            <ChevronLeft className="w-6 h-6 text-gray-800" />
          </button>
          <h1 className="text-lg font-semibold text-[#1e3a5f]">{title}</h1>
          <div className="w-10" />
        </div>

        {/* Main Content */}
        <div className="px-5 py-6 flex flex-col items-center justify-center min-h-[calc(100vh-140px)]">
          <div className="w-full max-w-md mx-auto flex flex-col items-center space-y-6">
            {/* Question Mark Icon - Replace with your image */}
            <div className="mb-8">
              <img 
                src="/Questionmark.png" 
                alt="Question Mark"
                className="w-50 h-50 md:w-60 md:h-60 lg:w-80 lg:h-80 object-contain"
              />
            </div>

            {/* Buttons */}
            <div className="w-full space-y-4">
              <button
                onClick={handleAskTufyClick}
                disabled={isNavigating}
                className="w-full py-4 px-6 rounded-lg bg-pink-100 hover:bg-pink-200 transition-colors duration-200 text-[#1e3a5f] font-medium text-base md:text-lg disabled:bg-gray-300"
              >
                {isNavigating ? "Checking..." : "Ask Tufy"}
              </button>

              <button
                onClick={() => navigate(`/talk-to-expert/${childId}`)}
                className="w-full py-4 px-6 rounded-lg bg-cyan-100 hover:bg-cyan-200 transition-colors duration-200 text-[#1e3a5f] font-medium text-base md:text-lg"
              >
                Talk to the Experts
              </button>

              <button
                onClick={() => navigate(`/CommunityChat/${childId}`)}
                className="w-full py-4 px-6 rounded-lg bg-[#1e3a5f] hover:bg-[#2d4a6f] transition-colors duration-200 text-white font-medium text-base md:text-lg"
              >
                Ask the Community
              </button>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
